'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _sfpReactCookieBanner = require("sfp-react-cookie-banner");

var _translate = _interopRequireDefault(require("../translate"));

var _config = _interopRequireDefault(require("./config"));

var _conf = require("../../conf");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.assign"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CookieBanner = /*#__PURE__*/function (_React$Component) {
  _inherits(CookieBanner, _React$Component);

  function CookieBanner(props) {
    var _this;

    _classCallCheck(this, CookieBanner);

    _this = _possibleConstructorReturn(this, (CookieBanner.__proto__ || Object.getPrototypeOf(CookieBanner)).call(this, props));
    _this.state = {
      config: Object.assign(_config.default, {
        cookieDomain: ".".concat(_conf.pageDomain)
      })
    };
    return _this;
  }

  _createClass(CookieBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n,
          iframe = _this$props.iframe,
          config = this.state.config;
      var translations = {};
      translations[i18n.language] = {
        consentNotice: {
          description: "\n                    <span class=\"title-wrapper\">\n                        <span></span>\n                        <span class=\"title\">".concat(t('cookie-banner-consent-notice-title'), "</span>\n                        <span></span>\n                    </span>\n                    <p class=\"body\">\n                        ").concat(t('cookie-banner-consent-notice-body'), "\n                    </p>\n                ")
        },
        ok: t('cookie-banner-consent-accept-button-title'),
        decline: t('cookie-banner-consent-decline-button-title')
      };
      return iframe.isIframe ? '' : /*#__PURE__*/_react.default.createElement(_sfpReactCookieBanner.SfpCookieBanner, {
        key: 'sfp-react-' + i18n.language,
        configs: Object.assign({}, config, {
          translations: translations
        })
      });
    }
  }]);

  return CookieBanner;
}(_react.default.Component);

CookieBanner.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    changeLanguage: _propTypes.default.func,
    options: _propTypes.default.shape({
      locales: _propTypes.default.arrayOf(_propTypes.default.string)
    })
  }),
  iframe: _propTypes.default.shape({
    isIframe: _propTypes.default.bool
  })
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, {
    iframe: state.iframe
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(CookieBanner));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/cookie-banner/index.js
// module id = 889
// module chunks = 0